<app-tcg-test-suites
  *ngIf="activeView === 'testSuites'"
  (viewTestCases)="onViewTestCases($event)"
></app-tcg-test-suites>

<app-tcg-test-case-detail
  *ngIf="activeView === 'testCaseDetail'"
  [suite]="selectedSuite"
  [showAddToSuite]="isBpdDetailView"
  [isImportFlow]="isImportDetailView"
  (importAddToSuite)="addImportedToTestSuite($event)"
  (importTestCases)="onImportTestCasesForSuite($event)"
  (back)="onBackToList()"
></app-tcg-test-case-detail>

<div *ngIf="activeView === 'userStories'" class="tcg-us-wrapper">
  <!-- ── Extraction progress line (matches Figma top-of-page indicator) ── -->
  <div class="tcg-extract-bar" *ngIf="showExtractionProgressUi">
    <div class="tcg-extract-bar-fill" [style.width.%]="extractionPct"></div>
  </div>

  <button type="button" class="tcg-us-back" (click)="onBackToList()">
    ← Back to Test Suites
  </button>
  <app-tcg-user-stories
    [stories]="extractedStories"
    [projectId]="projectId"
    [configId]="extractConfigId"
    [processingCounts]="processingCounts"
    [isProcessing]="isExtracting"
    [showCountsBar]="showExtractionProgressUi"
    [serverTotalElements]="storyTotalElements"
    [serverTotalPages]="storyTotalPages"
    [serverPageIndex]="storyPageIndex"
    [serverPageSize]="storyPageSize"
    (pageChange)="fetchStoryPage($event)"
    (generateTestCases)="onGenerateTestCases($event)">
  </app-tcg-user-stories>
</div>

<div *ngIf="activeView === 'testCases'" class="tcg-tc-wrapper">
  <button type="button" class="tcg-us-back" (click)="onBackToUserStories()">
    ← Back to User Stories
  </button>
  <app-expandable-accordion
    *ngIf="generatedTestCases"
    [data]="generatedTestCases"
    [showHeader]="true"
    [showSelectAll]="true"
    [showHeaderActions]="true"
    [showAddToSuiteButton]="true"
    [showFeedbackActions]="true"
    [showEmptyState]="true"
    [pageSize]="10"
    [showFilterButton]="true"
    [filterActive]="(isFilterActive$ | async) ?? false"
    [showDownloadButton]="true"
    [filterActive]="isTestCaseFilterActive"
    [testCoverageConfigs]="testCoverageConfigs"
    [feedbackSubmitting]="isUpdatingFeedback"
    (actionEmit)="onTestCasesAction($event)"
  ></app-expandable-accordion>
</div>
